import { call, put, select, takeLatest } from 'redux-saga/effects';
import * as constants from './constants';
import * as actions from './actions';
import * as api from './api';

/**
 * Saga to fetch nearby pins.
 * Sends JWT when available so the backend returns the user's own private tours.
 */
function* fetchNearbyPinsSaga(action) {
  try {
    const { lat, lng, radiusKm } = action.payload;
    const accessToken = yield select(state => state.Auth.accessToken);
    const data = yield call(api.fetchNearbyPins, lat, lng, radiusKm, accessToken);
    yield put(actions.fetchNearbyPinsSuccess(data));
  } catch (error) {
    console.error('Error fetching nearby pins:', error);
    yield put(actions.fetchNearbyPinsFailure(error.message));
  }
}

/**
 * Saga to fetch tour map data
 */
function* fetchTourMapSaga(action) {
  try {
    const { tourId } = action.payload;
    const data = yield call(api.fetchTourMap, tourId);
    yield put(actions.fetchTourMapSuccess(data));
  } catch (error) {
    console.error('Error fetching tour map:', error);
    yield put(actions.fetchTourMapFailure(error.message));
  }
}

/**
 * Root saga for map module
 */
export default function* mapSaga() {
  yield takeLatest(constants.FETCH_NEARBY_PINS_REQUEST, fetchNearbyPinsSaga);
  yield takeLatest(constants.FETCH_TOUR_MAP_REQUEST, fetchTourMapSaga);
}
